import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AnimatedCollapse } from '@backrs_ui/common-ui/src/atoms/AnimatedCollapse';
import { EmulationChip } from '@backrs_ui/common-ui/src/atoms/EmulationChip';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Tooltip, Typography, Avatar } from '@mui/material';
import { SIDEBAR_EXPANDED_WIDTH } from './sidebar.constants';
var EMULATION_LABEL = appStrings.modules.emulationChip.label;
export var ProfileWidget = function (_a) {
    var backrsUser = _a.backrsUser, isSidebarOpen = _a.isSidebarOpen, isEmulating = _a.isEmulating, toggleProfileMenu = _a.toggleProfileMenu;
    return (_jsxs(Box, { id: "sidebar-profile-avatar", sx: profileWidgetStyles(isSidebarOpen, isEmulating), onClick: toggleProfileMenu, children: [_jsxs(Box, { sx: profileImageNameContainer(isSidebarOpen, isEmulating), children: [_jsxs(Box, { sx: avatarWrapper, children: [_jsx(Avatar, { sx: profileImageContainer, src: backrsUser.profile_image, alt: "Profile photo", children: _jsx(Box, { sx: fallbackProfileImageContainer, children: _jsx(AppIcon, { iconName: "User01", diameter: "24px", color: 'Colors/Foreground/fg-quaternary' }) }) }), isEmulating && (_jsx(Tooltip, { title: EMULATION_LABEL, children: _jsx(Box, { sx: emulationDotSx, role: "img", "aria-label": EMULATION_LABEL }) }))] }), _jsx(AnimatedCollapse, { isOpen: isSidebarOpen, direction: "horizontal", opacityFade: true, children: _jsxs(Box, { sx: profileNameContainer(isSidebarOpen), children: [_jsxs(Typography, { variant: "text-sm-semibold", sx: profileNameTextSx, children: [backrsUser.first_name, " ", backrsUser.last_name] }), isEmulating ? (_jsx(EmulationChip, {})) : (_jsx(Typography, { sx: emailStyle, variant: "text-sm-regular", children: backrsUser.email }))] }) })] }), _jsx(AnimatedCollapse, { isOpen: isSidebarOpen, direction: "horizontal", opacityFade: true, children: _jsx(Box, { className: "profile-widget-chevron", sx: dropDownStyles(isSidebarOpen), children: _jsx(AppIcon, { iconName: "ChevronSelectorVertical", diameter: "20px", color: 'Colors/Foreground/fg-quinary' }) }) })] }));
};
var profileWidgetStyles = function (isSidebarOpen, isEmulating) {
    return function (_a) {
        var backrs = _a.backrs;
        var collapsedPaddingLeft = isEmulating
            ? backrs.spacing['spacing-none']
            : backrs.spacing['spacing-xs'];
        return {
            display: 'flex',
            alignItems: 'center',
            gap: isSidebarOpen ? backrs.spacing['spacing-xl'] : 0,
            paddingLeft: isSidebarOpen ? backrs.spacing['spacing-lg'] : collapsedPaddingLeft,
            paddingRight: isSidebarOpen ? backrs.spacing['spacing-lg'] : backrs.spacing['spacing-none'],
            paddingY: isSidebarOpen ? backrs.spacing['spacing-lg'] : backrs.spacing['spacing-none'],
            borderRadius: backrs.radius['radius-xl'],
            border: "1px solid ".concat(isSidebarOpen ? backrs.colors['Colors/Foreground/fg-primary'] : 'transparent'),
            boxShadow: backrs.shadows['shadow-xs'],
            justifyContent: 'space-between',
            transition: 'all 0.3s ease-in-out',
        };
    };
};
var avatarWrapper = {
    position: 'relative',
    display: 'inline-flex',
    flexShrink: 0,
};
var profileImageContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '40px',
        height: '40px',
        borderRadius: '200px',
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        transition: 'border 0.3s ease-in-out',
    });
};
var emulationDotSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '12px',
        height: '12px',
        borderRadius: backrs.radius['radius-full'],
        backgroundColor: backrs.colors['Colors/Foreground/fg-success-secondary'],
        border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-primary']),
    });
};
var fallbackProfileImageContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Colors/Background/bg-tertiary'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        borderRadius: '200px',
    });
};
var profileNameContainer = function (isSidebarOpen) {
    return function () { return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        minWidth: isSidebarOpen ? "".concat(SIDEBAR_EXPANDED_WIDTH / 2.2, "px") : 'unset',
    }); };
};
var profileNameTextSx = {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    textOverflow: 'ellipsis',
};
var profileImageNameContainer = function (isSidebarOpen, isEmulating) { return ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: !isSidebarOpen && isEmulating ? 'center' : 'flex-start',
    gap: isSidebarOpen ? 2 : 0,
    width: '100%',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}); };
var emailStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        overflow: 'hidden',
        flexWrap: 'nowrap',
        textOverflow: 'ellipsis',
        color: backrs.colors['Colors/Text/text-tertiary'],
    });
};
var dropDownStyles = function (isSidebarOpen) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            cursor: 'pointer',
            padding: backrs.spacing['spacing-sm'],
            paddingTop: 0,
            borderRadius: backrs.radius['radius-sm'],
            opacity: isSidebarOpen ? 1 : 0,
            transition: 'all 0.3s ease-in-out',
        });
    };
};
